import AmpService, { AMP_CATEGORY_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import Popover from "component/react-bootstrap/Popover";
import { useTranslation } from "next-i18next";
import { chunk } from "../../util/helper/chunk";
import { capitalize } from "../../util/lodash/capitalize";
import CategoryViewItem from "../categories-viewer/CategoryViewItem";
import toolbarStyle from "./toolbar.module.scss";

function PopoverComponent(props: any) {
  const {
    subCategory, style, ref, className, placement, t0, t1, closeToolbar,
  } = props;
  const { subs: tier2, filters } = subCategory;
  let subs = filters || tier2;
  const { t } = useTranslation("category-map");
  if (subs.length >= 6) {
    subs = chunk(subs, Math.ceil(subs.length / 2));
  } else {
    subs = chunk(subs, subs.length);
  }

  const innerStyle = placement === "right" ? { width: `${subs.length * 200}px` } : {};

  const onClick = (t2Category) => {
    if (closeToolbar) {
      closeToolbar();
    }
    AmpService.categoryClick({
      tier0: t0,
      tier1: t1,
      tier2: typeof t2Category === "string" ? t2Category : t2Category?.filter?.tier2,
    }, AMP_CATEGORY_LOCATIONS.TOOLBAR);
  };

  return (
    <Popover
      ref={ref}
      style={{ ...style, width: `${subs.length * 200}px` }}
      placement={placement}
      className={className}
    >

      <div className={`${toolbarStyle.popover_body} row`} style={innerStyle}>
        {subs.map((row: any) => (
          <div
            key={row.length + (row.length ? row[0] : "NoLength")}
            className={`col-sm-${12 / subs.length}`}
          >

            <ul className="list-unstyled">
              {row.map((t2Category: any) => {
                const defaultFilters = {};
                if (t2Category.filter) {
                  Object.keys(t2Category.filter).forEach((key) => {
                    defaultFilters[key] = t(t2Category.filter[key]);
                  });
                }
                return (

                  <CategoryViewItem
                    key={t2Category.name}
                    categoryObj={{
                      tier0: (t0),
                      tier1: (t1),
                      tier2: typeof t2Category === "string" ? (capitalize(t2Category)) : (capitalize(t2Category?.filter?.tier2)),
                    }}
                    defaultFilters={defaultFilters}
                  >

                    <li onClick={() => onClick(t2Category)}>
                      {typeof t2Category === "string" ? t(t2Category) : t(t2Category.label)}
                    </li>
                  </CategoryViewItem>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </Popover>
  );
}

export default PopoverComponent;
